"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

require("core-js/es6/promise");

require("core-js/es6/object");

var typescript_observable_1 = require("typescript-observable");

var task_events_1 = require("./task-events");

var TaskQueue =
/** @class */
function (_super) {
  __extends(TaskQueue, _super);
  /**
   *
   * @param {ITaskQueueConfig} config
   */


  function TaskQueue(config) {
    var _this = _super.call(this) || this;

    _this.tasks = [];
    _this.isRunning = false;
    _this.isStopped = false;
    _this.config = Object.assign({}, {
      autoRun: false,
      stoppable: true
    }, config);
    return _this;
  }
  /**
   * Add a new task to the end of the queue. A single element or a list can be added. If config.autoRun then this
   * function will start a the execution of the tasks.
   * @param {Function | Function[]} task is the task that will be added to the queue
   */


  TaskQueue.prototype.enqueue = function (task) {
    // Check if the task is an array of tasks
    if (Array.isArray(task)) {
      this.tasks.push.apply(this.tasks, task);
    } else {
      this.tasks.push(task);
    } // Check if autoRun is true


    if (this.config.autorun) {
      this.start();
    }
  };
  /**
   * Start the execution of the tasks
   */


  TaskQueue.prototype.start = function () {
    this.isStopped = false;

    if (!this.isRunning) {
      this.notify(task_events_1.StartEvent, {});
      this.execute();
    }
  };
  /**
   * Stop the execution of the tasks
   */


  TaskQueue.prototype.stop = function () {
    if (this.config.stoppable) {
      this.isStopped = true;
    }
  };

  TaskQueue.prototype.execute = function () {
    var _this = this; // If there is more than one task in the queue and this is not stopped.


    if (!this.isStopped && this.tasks.length > 0) {
      // Set status to running
      this.isRunning = true; // Get the first task

      var task_1 = this.tasks.shift() || function () {}; // Run the task decoupled and start the next


      Promise.resolve().then(function () {
        task_1();

        _this.execute();
      });
    } else {
      // Set status to not running
      this.isRunning = false;
      this.notify(task_events_1.StopEvent, {
        wasStopped: this.isStopped
      });
    }
  };

  return TaskQueue;
}(typescript_observable_1.Observable);

exports.TaskQueue = TaskQueue;